export default __webpack_public_path__ + "static/sirisha-bandla-mobile-f025ffe76bccf62e618d082abf8b95e4.jpg";